import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useCallback, useMemo } from "react";

import { FuncionarioDropDown } from "../../../../../../common/domain/models/funcionario_dropdown";
import { FuncionarioTercDropDown } from "../../../../../../common/domain/models/funcionario_terc_dropdown";

type Props = {
  open: boolean;
  idsFuncionarios: number[];
  tipoMaoDeObra: number; 
  funcionarioDropdown: FuncionarioDropDown[] | [];
  funcionarioTerceirizadoDropdown: FuncionarioTercDropDown[] | []; 
  onClose: () => void;
};

export const EfetivoFuncionariosModal = ({
  open,
  idsFuncionarios,
  tipoMaoDeObra,
  funcionarioDropdown,
  funcionarioTerceirizadoDropdown,
  onClose,
}: Props) => {
  
  const funcionariosVinculados = useMemo(() => {
    if (!idsFuncionarios || idsFuncionarios.length === 0) return [];

    if (tipoMaoDeObra === 0) {
      // 0 = Própria
      return funcionarioDropdown
        .filter((f) => idsFuncionarios.includes(f.idFuncionario))
        .map((f) => ({ id: f.idFuncionario, nome: f.nome }));
    } else {
      // 1 = Terceirizada
      return funcionarioTerceirizadoDropdown
        .filter((f) => idsFuncionarios.includes(f.idFuncionarioTerc))
        .map((f) => ({ id: f.idFuncionarioTerc, nome: f.nome }));
    }
  }, [idsFuncionarios, tipoMaoDeObra, funcionarioDropdown, funcionarioTerceirizadoDropdown]);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth="sm"
      onClose={handleClose}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "32rem",
          },
        },
      }}
    >
      <DialogTitle>Funcionários Vinculados</DialogTitle>

      <DialogContent dividers>
        <div className="w-full min-h-[150px] flex flex-col gap-2 p-2">
          {funcionariosVinculados.length > 0 ? (
            <ul className="list-disc pl-5 flex flex-col gap-1">
              {/* 👇 Renderiza usando o objeto padronizado { id, nome } */}
              {funcionariosVinculados.map((func) => (
                <li
                  key={func.id}
                  className="text-sm font-medium text-gray-700 dark:text-gray-200"
                >
                  {func.nome}
                </li>
              ))}
            </ul>
          ) : (
            <div className="w-full h-full flex items-center justify-center text-gray-500 text-sm font-medium">
              Nenhum funcionário vinculado a este registro.
            </div>
          )}
        </div>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-end flex p-2 gap-4">
          <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
            <h1
              className="text-sm text-black dark:text-white"
              onClick={handleClose}
            >
              Fechar
            </h1>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
};
